import React from 'react';
import { HiOutlineArrowLeft } from 'react-icons/hi';
import { RxArrowLeft } from 'react-icons/rx';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from 'src/context/UserProvider';
import { useGetOfflineDrivePositions } from 'src/hooks/offlineDrive.hooks';

const CandidatesPositionPageHeader = ({
	positionId,
	totalCandidates,
}: {
	positionId: string;
	totalCandidates: number;
}) => {
	const navigate = useNavigate();
	const { selectedDrive } = useUserContext();
	const { data: offlineDrivePositionData, isLoading } = useGetOfflineDrivePositions({
		driveId: selectedDrive?.value || '',
		positionId: positionId,
		page: 0,
		limit: 10,
	});

	return (
		<div className="flex items-center text-base md:text-xl font-[600] text-[#1C1C28] pb-4 md:pb-[20px] border-b border-[#E4E4EB] mb-4">
			<button
				className="mr-2 my-auto font-inter text-[#1C1C28] flex justify-center items-center w-fit"
				onClick={() => {
					navigate('/offline-drive-companies');
				}}
			>
				<HiOutlineArrowLeft size={20} color="#1C1C28" />
			</button>
			<span className="text-[#1C1C28] capitalize">{offlineDrivePositionData?.positions[0]?.company?.name}</span>
			<span className="text-[#1C1C28] ml-1">Shortlisted Candidates ({totalCandidates})</span>
		</div>
	);
};

export default CandidatesPositionPageHeader;
